import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  layerSize: PropTypes.instanceOf(Object).isRequired,
  engraving: PropTypes.instanceOf(Object).isRequired,
  selectedCase: PropTypes.instanceOf(Object).isRequired,
};

const EngravingLayer = ({ layerSize, engraving, selectedCase }) => {
  const height = `${layerSize.height}px`;
  const width = `${layerSize.width}px`;
  const fontSize = `${64 * (layerSize.height / 1679)}px`;
  const letterSpacing = 6 * (layerSize.height / 1679);

  const getStyleValues = () => {
    if (selectedCase.selected === "steelBlack") {
      return {
        fontColorOpacity: 0.6,
        shadowOpacity: 0.15,
        top: "50%",
        left: "50%",
      };
    }
    return {
      fontColorOpacity: 0.35,
      shadowOpacity: 0.5,
      top: "48.85%",
      left: "50%",
    };
  };

  const styleValues = getStyleValues();

  return (
    <div
      className="absolute engraving-container"
      style={{
        "--container-height": height,
        "--container-width": width,
      }}
    >
      <div
        className="engraving-text absolute w-2/5"
        style={{
          "--font-size": fontSize,
          "--background-color-opacity": styleValues.fontColorOpacity,
          "--shadow-opacity": styleValues.shadowOpacity,
          "--top": styleValues.top,
          "--left": styleValues.left,
          "letter-spacing": letterSpacing,
        }}
      >
        {engraving.text}
      </div>
    </div>
  );
};

EngravingLayer.propTypes = propTypes;

export default EngravingLayer;
